"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdjustParamsActionType = exports.LeverageSettingCheckReason = exports.ReducePositionCheckFailedReason = exports.PauseResumeType = exports.HedgeGridTrendSLTPSettingType = exports.TransferDirection = exports.TransferType = exports.WithDrawProfitCheckReason = exports.GridHedgeFuturesHedgeType = exports.AdjustParamsCheckReason = exports.AdjustParamsType = exports.GridV4FutureAIRiskType = void 0;
const TradeAPILib_1 = require("TradeAPILib");
/** AI参数的风险等级 */
var GridV4FutureAIRiskType;
(function (GridV4FutureAIRiskType) {
    /** 保守型 */
    GridV4FutureAIRiskType["conservative"] = "conservative";
    /** 均衡型 */
    GridV4FutureAIRiskType["robust"] = "robust";
    /** 激进型 */
    GridV4FutureAIRiskType["radical"] = "radical";
})(GridV4FutureAIRiskType || (exports.GridV4FutureAIRiskType = GridV4FutureAIRiskType = {}));
var AdjustParamsType;
(function (AdjustParamsType) {
    /** 加仓 */
    AdjustParamsType["invest_in"] = "invest_in";
    /** 减仓 */
    AdjustParamsType["invest_out"] = "invest_out";
    /** 修改区间 */
    AdjustParamsType["adjust_params"] = "adjust_params";
    /** 开仓 */
    AdjustParamsType["open"] = "open";
    /** 关单 */
    AdjustParamsType["close"] = "close";
    /** 暂停 */
    AdjustParamsType["pause"] = "pause";
    /** 重启 */
    AdjustParamsType["resume"] = "resume";
    /** 关单帮卖 */
    AdjustParamsType["sell_to_usdt"] = "sell_to_usdt";
    /** 分润 */
    AdjustParamsType["share_ratio"] = "share_ratio";
    /** 修改杠杆 */
    AdjustParamsType["update_leverage"] = "update_leverage";
    /** 发财金回收 */
    AdjustParamsType["bonus_back"] = "bonus_back";
    /** 服务端投U的数据 */
    AdjustParamsType["open_buy_quote"] = "open_buy_quote";
})(AdjustParamsType || (exports.AdjustParamsType = AdjustParamsType = {}));
var AdjustParamsCheckReason;
(function (AdjustParamsCheckReason) {
    /** 加仓后总权益≤占用保证金 */
    AdjustParamsCheckReason["MARGIN_NOT_ENOUGH"] = "MARGIN_NOT_ENOUGH";
    /** 加仓后总仓位>最大仓位名义价值限制 */
    AdjustParamsCheckReason["EXCEED_NOTIONAL_LIMIT"] = "EXCEED_NOTIONAL_LIMIT";
    /** 暂无加仓额度 */
    AdjustParamsCheckReason["NO_ADD_POSITION_QUOTA"] = "NO_ADD_POSITION_QUOTA";
    /** 按当前追加投资额之后，依然小于新参数需要的最小投资额 */
    AdjustParamsCheckReason["LESS_THAN_MIN_INVESTMENT"] = "LESS_THAN_MIN_INVESTMENT";
    /** 按当前追加投资额之后, 依然超过新参数所支持的最大投资额 */
    AdjustParamsCheckReason["GREATE_THAN_MAX_INVESTMENT"] = "GREATE_THAN_MAX_INVESTMENT";
    /** 按当前追加投资额之后，依然小于新参数且per_volume不变需要的最小投资额 */
    AdjustParamsCheckReason["LESS_THAN_MIN_INVESTMENT_RECOMMEND"] = "LESS_THAN_MIN_INVESTMENT_RECOMMEND";
    /** 选择不复投时总利润小于0 */
    AdjustParamsCheckReason["PROFIT_LESS_THAN_ZERO"] = "PROFIT_LESS_THAN_ZERO";
})(AdjustParamsCheckReason || (exports.AdjustParamsCheckReason = AdjustParamsCheckReason = {}));
var GridHedgeFuturesHedgeType;
(function (GridHedgeFuturesHedgeType) {
    /** 多空双开 只对 做多操作 */
    GridHedgeFuturesHedgeType["long"] = "long";
    /** 多空双开 只对 做空操作 */
    GridHedgeFuturesHedgeType["short"] = "short";
    /** 多空双开 对 做多做空都有的操作 */
    GridHedgeFuturesHedgeType["hedge"] = "hedge";
})(GridHedgeFuturesHedgeType || (exports.GridHedgeFuturesHedgeType = GridHedgeFuturesHedgeType = {}));
var WithDrawProfitCheckReason;
(function (WithDrawProfitCheckReason) {
})(WithDrawProfitCheckReason || (exports.WithDrawProfitCheckReason = WithDrawProfitCheckReason = {}));
var TransferType;
(function (TransferType) {
    TransferType["profit"] = "profit";
    TransferType["margin"] = "margin";
})(TransferType || (exports.TransferType = TransferType = {}));
var TransferDirection;
(function (TransferDirection) {
    TransferDirection["in"] = "in";
    TransferDirection["out"] = "out";
})(TransferDirection || (exports.TransferDirection = TransferDirection = {}));
var HedgeGridTrendSLTPSettingType;
(function (HedgeGridTrendSLTPSettingType) {
    HedgeGridTrendSLTPSettingType["condition"] = "condition";
    HedgeGridTrendSLTPSettingType["stop-loss"] = "stop-loss";
    HedgeGridTrendSLTPSettingType["stop-profit"] = "stop-profit";
    HedgeGridTrendSLTPSettingType["price_diff_limit"] = "price_diff_limit";
    HedgeGridTrendSLTPSettingType["open_price_diff_limit"] = "open_price_diff_limit";
    HedgeGridTrendSLTPSettingType["close_price_diff_limit"] = "close_price_diff_limit";
})(HedgeGridTrendSLTPSettingType || (exports.HedgeGridTrendSLTPSettingType = HedgeGridTrendSLTPSettingType = {}));
var PauseResumeType;
(function (PauseResumeType) {
    PauseResumeType["pause"] = "pause";
    PauseResumeType["resume"] = "resume";
})(PauseResumeType || (exports.PauseResumeType = PauseResumeType = {}));
var ReducePositionCheckFailedReason;
(function (ReducePositionCheckFailedReason) {
    ReducePositionCheckFailedReason["LOSS_GTE_INVESTMENT"] = "LOSS_GTE_INVESTMENT";
    ReducePositionCheckFailedReason["POSITION_TOO_SMALL"] = "POSITION_TOO_SMALL";
    ReducePositionCheckFailedReason["REDUCE_TOO_MUCH"] = "REDUCE_TOO_MUCH";
})(ReducePositionCheckFailedReason || (exports.ReducePositionCheckFailedReason = ReducePositionCheckFailedReason = {}));
// 调整杠杆类型
var LeverageSettingCheckReason;
(function (LeverageSettingCheckReason) {
    LeverageSettingCheckReason["INVALID_LEVERAGE"] = "INVALID_LEVERAGE";
    LeverageSettingCheckReason["DELTA_QUOTE_INVETMENT_TOO_SMALL"] = "DELTA_QUOTE_INVETMENT_TOO_SMALL";
    LeverageSettingCheckReason["INSUFFICIENT_BALANCE"] = "INSUFFICIENT_BALANCE";
})(LeverageSettingCheckReason || (exports.LeverageSettingCheckReason = LeverageSettingCheckReason = {}));
var AdjustParamsActionType;
(function (AdjustParamsActionType) {
    AdjustParamsActionType["Direct"] = "Direct";
    AdjustParamsActionType["WithInvestment"] = "WithInvestment";
    AdjustParamsActionType["WithInvestmentAndMargin"] = "WithInvestmentAndMargin";
    AdjustParamsActionType["ProfitDirect"] = "ProfitDirect";
    AdjustParamsActionType["ProfitWithInvestment"] = "ProfitWithInvestment";
})(AdjustParamsActionType || (exports.AdjustParamsActionType = AdjustParamsActionType = {}));
